function isScrollable(el: HTMLElement) {
	const overflowY = getComputedStyle(el).overflowY;
	return (
		(overflowY === "auto" ||
			overflowY === "scroll" ||
			overflowY === "overlay") &&
		el.scrollHeight > el.clientHeight
	);
}

/** Nearest scrollable ancestor, or `null` when the document scrolls the page. */
export function getScrollParent(el: HTMLElement): HTMLElement | null {
	let node = el.parentElement;
	while (node) {
		if (isScrollable(node)) {
			return node;
		}
		node = node.parentElement;
	}
	return null;
}
